const getBrandId = state => state.brandId
const getUrl = state => state.url
const getShowPoweredBy = state => state.showPoweredBy
const getPrimaryColor = state => state.primaryColor
const getSecondaryColor = state => state.secondaryColor
const getIconPrimaryColor = state => state.iconPrimaryColor
const getIconSecondaryColor = state => state.iconSecondaryColor
const getFontColor = state => state.fontColor
const getImages = state => state.images
const getBrandLoadingStatus = state => state.brandLoadingStatus

const getLoginImageUri = state => {
    return state.images['0'] ? state.images['0'].uri : null
}
const getNavigationImageUri = state => {
    return state.images['1'] ? state.images['1'].uri : null
}
const getReportImageUri = state => {
    return state.images['2'] ? state.images['2'].uri : null
}
const getEmailImageUri = state => {
    return state.images['3'] ? state.images['3'].uri : null
}
const getFaviconImageUri = state => {
    return state.images['4'] ? state.images['4'].uri : null
}

export default {
    getBrandId,
    getUrl,
    getShowPoweredBy,
    getPrimaryColor,
    getSecondaryColor,
    getFontColor,
    getImages,
    getLoginImageUri,
    getNavigationImageUri,
    getReportImageUri,
    getEmailImageUri,
    getFaviconImageUri,
    getBrandLoadingStatus,
    getIconPrimaryColor,
    getIconSecondaryColor
}
